import * as DOMPurify from 'dompurify';
import React from "react";
import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import { connect } from 'react-redux';
import { Subscribe } from "unstated";
import {
  callReduxAlertAction,
  globalVars
} from "../../App";
import infoIcon from "../../Images/info.png";
import uploadIcon from "../../Images/upload.png";
import { checkHideCustNumCallComplete, checkShowInvoiceAmountField, setHideCustomerNum, storeCustomerFields } from "../../redux/actions/callCompletedAction";
import { store as reduxStore } from "../../redux/store";
import InvoiceDataContainer from "../../Stores/InvoiceDataContainerStore";
import { myGlobals, myUtilities } from "../../Utils";
import { checkAndScanFile, uploadFileToS3, validateStaticInvoiceData } from "../../Utils/AjaxUtil";
import FirstLoading from "../../Views/FirstLoading";
import { MarketingText, StaticInput } from "../Common";
import CustomLoader from "../Common/CustomLoader";

class TopBuildPayThroughEmailForm extends React.Component {
  constructor(props) {
    super(props);
    this.callDone = false;
    this.state = {
      customerNumber: null,
      invoices: null,
      hideCustomerNumber: false,
      showInvoiceAmountField: false,
      fileName: "",
      showCustomLoader: false,
      customerFieldsState: {}
    };
    this.checkToRenderCustomerNumField();
    if(this.props.checkIfCallComplete)
      this.state = {
          ...this.state,
          showInvoiceAmountField : this.props.showInvoiceAmountFieldRedux
      }
  }
  scanAndUploadFile = async (fileToSet, invData) => {
    await this.setState({ showCustomLoader: true });

    const fileScanResult = await checkAndScanFile(fileToSet.name, fileToSet);

    if (fileScanResult && JSON.parse(fileScanResult).plainScanResult === "SCAN_RESULT:CLEAN") {
      const fileUploadPath = await uploadFileToS3(fileToSet.name, fileToSet);
      if (fileUploadPath !== undefined && fileUploadPath !== "") {
        this.setState({ fileName: fileUploadPath });

        validateStaticInvoiceData(invData, JSON.stringify(this.state), this.responseHandler);


      } else
        callReduxAlertAction(
          "generic.pte.invalidFileuploadFail",
          "File upload failed. Please check the file again."
        );
    } else
      callReduxAlertAction(
        "generic.pte.invalidFileScanResult",
        "File scanning failed. Please check the file again."
      );
    await this.setState({ showCustomLoader: false });
  };
  checkToRenderCustomerNumField = async () => {
	    if(this.props.checkIfCallComplete)
	        return;
	    const self = this;
	    const searchParams = new URLSearchParams();
	    searchParams.append("token", myGlobals.token);
	    let link = "checkHideCustomerNumber";
	    link = myGlobals.initialHost + myGlobals.appender + link;
	    // link = "https://api.jsonbin.io/b/5fd893f5bef8b7699e59d106/1";
      await fetch(link, {
	      // method: "GET",
	      // headers: {
	      //   "secret-key":
	      //     "$2b$10$V7Yj/PzFJS.MX80bYHIji.ocR9meNY9i6gHR6YjKjZkl9Qn8wGA9a",
	      // },

	      method: 'POST',
	      body: searchParams
	    })
	      .then(function (response) {
	        if (response.status !== 200) {
	          console.log(
	            "Looks like there was a problem. Status Code: " + response.status
	          );
	          return;
	        }
	        return response.json();
	      })
	      .then(function (data) {	        
	          
	        if (data.rows !== undefined ) {
            let hideCustomerNumber = data.rows.hideCustomerNumber !== undefined ? data.rows.hideCustomerNumber : false;
            let showInvoiceAmountField = data.rows.showInvoiceAmountField !== undefined ? data.rows.showInvoiceAmountField : false;
            let customerFields = data.rows.customerFields ?? [];

	            self.setState({hideCustomerNumber, showInvoiceAmountField})
	            reduxStore.dispatch(setHideCustomerNum(hideCustomerNumber));
              reduxStore.dispatch(checkShowInvoiceAmountField(showInvoiceAmountField));
              reduxStore.dispatch(storeCustomerFields(customerFields))
              if(showInvoiceAmountField){
               
                self.setState({
                  invoice1: "", invoice2:"",invoice3:"",invoice4:"",invoice5:"",
                  "invoice-amount1":"-1","invoice-amount2":"-1","invoice-amount3":"-1","invoice-amount4":"-1",
                  "invoice-amount5":"-1"
                })
              }
            
	        }

	        reduxStore.dispatch(checkHideCustNumCallComplete());

	      })
	      .catch(function (err) {
	        console.log("Fetch Error :-S", err);
	        reduxStore.dispatch(checkHideCustNumCallComplete());
	      });
	 };
  formSetState = (index, data) => {
  	if(index && typeof index === "string" &&  index.includes("invoice-amount") && (isNaN(data) || data === "NaN") ) data = "-1";
    let obj = "{" + '"' + index + '"' + ":" + '"' + data + '"' + "}";
    this.setState(JSON.parse(obj));
  };
  responseHandler = async (data, invdata) => {
    if (!this.callDone) {
    	globalVars.isTopBuild = true;
      if(data.rows && data.rows.status && data.rows.status === "Invalid_Invoices") {
        callReduxAlertAction(
          "generic.pte.invalidFileProvided",
          "Failed to process file since more than 1000 rows were found. Please check again."
        );
      } else if(data.rows && data.rows.status && data.rows.status === "NO_INVOICES_FOUND") {
        callReduxAlertAction(
          "generic.pte.invalidNoInvoicesFound",
          "No matching invoices found. Please check again."
        );
      } else if (data.rows.status.localeCompare("invalid") === 0) {
        callReduxAlertAction(
          "generic.pte.invalid",
          "Please enter correct customer-invoice combination"
        );
      } else if (data.rows.status.localeCompare("MULTIPLE_CURRENCIES") === 0) {
        callReduxAlertAction(
          "generic.pte.multiCurrency",
          "Please enter invoices having same currency"
        );
      }else if (data.rows.status.localeCompare("INVOICE_BLOCKED") === 0) {
        callReduxAlertAction(
          "generic.pte.invoiceBlocked",
          "Invoice(s) entered have been blocked by the administrator"
        );
      } else {
    	globalVars.paymentCardKeyCount = new Set();
        globalVars.selectedCard = -1;
        await invdata.populateData(data);
        myGlobals.topBuildResponse = data;
        myGlobals.paymentLimitsMap = data.rows.paymentLimits;
        this.props.history.replace(`/mainapp`);
        this.callDone = true;
        this.updateGuestLoginStatus();
      }
    }
  };
  isValidFormDataForInvoiceAmounts = () => {
    let fixedInvs = [1,2,3,4,5];
    let isFormValid = true;
    fixedInvs.forEach(num => {
      const invoiceNumber = this.state["invoice" + num];
      const invoiceAmount = this.state["invoice-amount" + num];
      if((invoiceNumber !== "" && invoiceAmount === "-1" )||
            (invoiceNumber === "" && invoiceAmount !== "-1" ))
        isFormValid = false;
    })
    return isFormValid;
  }
  updateGuestLoginStatus = () => {
    const searchParams = new URLSearchParams();
    searchParams.append("token", myGlobals.token);
    let link = "updateGuestLoginHistoryStatus";
    link = myGlobals.initialHost + myGlobals.appender + link;
    fetch(link, {
      method: "POST",
      body: searchParams,
    })
      .then(function (response) {
        if (response.status !== 200) {
          return;
        }
        return response.json();
      })
      .catch(function (err) {});
  };
  onSubmit = (invData, onSuccess) => {
    if (
      this.state.customerNumber &&
      this.state.customerNumber.trim().length > 0 &&
      this.state.invoices &&
      this.state.invoices.trim().length > 0 &&
      this.state.invoices.split(",").length <= 1000
    ) {
      let token = invData.state.token;
      const searchParams = new URLSearchParams();
      searchParams.append("token", token);
      searchParams.append("customerNumber", this.state.customerNumber);
      searchParams.append("invoiceNumbers", this.state.invoices);
      if (this.state.custIdentifier1 != undefined)
        searchParams.append("custIdentifier1", this.state.custIdentifier1);
      
      if (this.state.custIdentifier2 != undefined)
        searchParams.append("custIdentifier2", this.state.custIdentifier2);

      if (this.state.custIdentifier3 != undefined)
        searchParams.append("custIdentifier3", this.state.custIdentifier3);

      if (this.state.custIdentifier4 != undefined)
        searchParams.append("custIdentifier4", this.state.custIdentifier4);

      if (this.state.custIdentifier5 != undefined)
        searchParams.append("custIdentifier5", this.state.custIdentifier5);

      
      let link = "topBuildValidateInvoice";
      link = myGlobals.initialHost + myGlobals.appender + link;
      fetch(link, {
        method: "POST",
        body: searchParams,
      })
        .then(function (response) {
          if (response.status !== 200) {
            console.log(
              "Looks like there was a problem. Status Code: " + response.status
            );
            throw new Error("Status: " + response.status);
          }
          //console.log(response.text());
          return response.json();
        })
        .then(function (data) {
          onSuccess(data, invData);
        })
        .catch(function (err) {
          console.log("Fetch Error :-S", err);
          callReduxAlertAction(
            "failure.generic.remittance.alert",
            "Validations failed, please enter correct data"
          );
        });
    } else if( this.props.hideCustomerNumber && this.state.invoices &&
    	      this.state.invoices.trim().length > 0 &&
    	      this.state.invoices.split(",").length <= 1000) {
    	      
    	      


    	      let token = invData.state.token;
    	      const searchParams = new URLSearchParams();
    	      searchParams.append("token", token);
    	      searchParams.append("invoiceNumbers", this.state.invoices);
    	      let link = "topBuildValidateInvoice";
    	      link = myGlobals.initialHost + myGlobals.appender + link;
    	      fetch(link, {
    	        method: "POST",
    	        body: searchParams
    	      })
    	        .then(function (response) {
    	          if (response.status !== 200) {
    	            console.log(
    	              "Looks like there was a problem. Status Code: " + response.status
    	            );
    	            throw new Error("Status: " + response.status);
    	          }
    	          //console.log(response.text());
    	          return response.json();
    	        })
    	        .then(function (data) {
    	          onSuccess(data, invData);
    	        })
    	        .catch(function (err) {
    	          console.log("Fetch Error :-S", err);
    	          callReduxAlertAction(
    	            "failure.generic.remittance.alert",
    	            "Validations failed, please enter correct data"
    	          );
    	        });
    	    } else if(this.state.showInvoiceAmountField) {

            this.setState({fileName : ''}); 

            if(this.state.invoice1 && (this.state.invoice1 === '' || this.state["invoice-amount1"] === -1) ) {
              callReduxAlertAction(
                "failure.generic.invoice.MinCriteriafailed",
                "Validations failed, atleast one invoice and amount combination should be provided."
              );
              return;
            }

          if(!this.isValidFormDataForInvoiceAmounts()) {
                callReduxAlertAction(
                  "failure.generic.invoice.InvalidFormDaata",
                  "Validations failed, please check if all amount data is present for the corresponding invoice numbers"
                );
                return;
            }

            let sendingData = JSON.parse(JSON.stringify(this.state));
            sendingData['fileName'] = '';
            sendingData['custIdentifier1'] = this.state.custIdentifier1;
            sendingData['custIdentifier2'] = this.state.custIdentifier2;
            sendingData['custIdentifier3'] = this.state.custIdentifier3;
            sendingData['custIdentifier4'] = this.state.custIdentifier4;
            sendingData['custIdentifier5'] = this.state.custIdentifier5;

            validateStaticInvoiceData(invData, JSON.stringify(sendingData), onSuccess,this.props.hideCustomerNumber)
    	      .then(function (data) {
    	          onSuccess(data, invData);
    	        })
    	        .catch(function (err) {
    	          console.log("Fetch Error :-S", err);
    	          callReduxAlertAction(
    	            "failure.generic.remittance.alert",
    	            "Validations failed, please enter correct data"
    	          );
    	        });
                

          } else if (this.state.invoices.split(",").length > 1000)
      callReduxAlertAction(
        "failure.generic.invoice.maxlimit.alert",
        "Validations failed, do not enter more than 1000 invoices"
      );
  };

  renderInvoiceNumberFields = (invData) => {
    if (this.state.showInvoiceAmountField) {
      return <>  {this.state.showCustomLoader && (
            <CustomLoader
              messageID="alert.staticInvoice.fileScan"
              defaultMessage="Please wait. Scanning and processing file"
            />
          )}
           {[1,2,3,4,5].map(num => <div style={{display: 'flex'}}>
      <StaticInput
                isTopBuildInvoice
                isRequired = {num === 1 }
                showInvoiceAmountField = {this.state.showInvoiceAmountField}
                formSetState={this.formSetState}
                className="topbuild-row-margin-top static-input-invAmount"
                name={"invoice"+num}
                label={
                  <div className="static-input">
                    {myUtilities.accountSpecificLanguage(
                      "generic.pte.form.invoice",
                      "Invoice Number"
                    )}
                  </div>
                }
              />
      
      <StaticInput
                isTopBuildInvoice
                isRequired = {num === 1 }
                formSetState={this.formSetState}
                isNumber={true}
                showInvoiceAmountField = {this.state.showInvoiceAmountField}
                className="topbuild-row-margin-top static-input-invAmount"
                name={"invoice-amount"+num}
                label={
                  <div className="static-input">
                    {myUtilities.accountSpecificLanguage(
                      "generic.pte.form.invoiceAmount",
                      "Invoice Amount"
                    )}
                  </div>
                }
              />
      
              
      
            </div>)} 
                      <div className="static-upload-container">
            <span>
              <label className="static-input-file-label" for="inputTag">
                <img src={uploadIcon} />
              </label>
              <input
                accept=".csv,.xls,.xlsx,.CSV,.XLS,.XLSX"
                onChange={
                  (evt) => {
                    let files = evt?.target?.files;
                    let fileToSet = "";
                    if (
                      files &&
                      files[0] &&
                      ["csv", "xls", "xlsx"].includes(
                        files[0].name.split(".").pop().toLocaleLowerCase()
                      )
                    ) {
                      fileToSet = files[0];
                    } else
                      callReduxAlertAction(
                        "generic.pte.invalidFileType",
                        "Incorrect file type. Please choose a valid csv, xls or xlsx file."
                      );
                    if (fileToSet === "") return;
                    
                    if (this.props.hideCustomerNumber)
                      this.scanAndUploadFile(fileToSet, invData);
                    else if (
                      this.state.customerNumber &&
                      this.state.customerNumber.trim().length > 0
                    )
                      this.scanAndUploadFile(fileToSet, invData);
                    else
                      callReduxAlertAction(
                        "generic.pte.CustomerNotFound",
                        "Please enter customer number to proceed."
                      );
                    
                  }
                }
                id="inputTag"
                type="file"
              />
            </span>
            <img
			  className="static-info-icon-button-label"
              src={infoIcon}
              title={myUtilities.accountSpecificLanguage(
                "generic.pte.form.invoiceAmountInfoButton",
                "For more than 5 invoices, upto 1000 invoices; \nupload a csv, xls or xlsx file with 2 columns: \nColumn 1: Invoice Number \nColumn 2: Invoice Total"
              )}
            />
          </div>
            </>;
    } else
      return (
        <StaticInput
          isTopBuildInvoice
          isRequired
          formSetState={this.formSetState}
          className="topbuild-row-margin-top"
          name="invoices"
          label={
            <div className="static-input">
              {myUtilities.accountSpecificLanguage(
                "generic.pte.form.invoice",
                "Invoice Number"
              )}
            </div>
          }
        />
      );
  };

  createCustomerFields = () => {
    if(Array.isArray(this.props.customerFields)) {
      return this.props.customerFields.map((field) => (
          <StaticInput
        isTopBuildInvoice
        formSetState={this.formSetState}
        isDropdownField
        dropDownValues={field.dropDownValues}
        className="topbuild-row-margin-top topbuild-customer-number-field-input"
        name={DOMPurify.sanitize(field.name)}
        label={DOMPurify.sanitize(field.displayName)} 
        />

      ))
    }
  }

  render() {
    return (
      <Subscribe to={[InvoiceDataContainer]}>
        {(data) => (
        this.props.checkIfCallComplete ? <>
		  <MarketingText
		        textId="Header.MarketingText.Invoice"
		        defaultMessage="Make Payments on Invoice" />
		     <Container className="pte-static-div">
            <Row className={"adjust-top-margin inv-amt-margin-top-" + DOMPurify.sanitize(this.props.showInvoiceAmountFieldRedux)} />
            <Row>
              <Col className="center-element bold">
              {myUtilities.accountSpecificLanguage(
                this.props.hideCustomerNumber ? "generic.pte.InvoiceHeading"  : "generic.pte.Heading", 
                this.props.hideCustomerNumber ? "Enter your Invoice Details" : "Enter your Customer & Invoice Details")}
              </Col>
            </Row>
            <form
              action="javascript:void(0);"
              onSubmit={() => this.onSubmit(data, this.responseHandler)}
            >
            {!this.props.hideCustomerNumber && <StaticInput
                isTopBuildInvoice
                isRequired
                formSetState={this.formSetState}
                className="topbuild-row-margin-top topbuild-customer-number-field-input"
                name="customerNumber"
                label={
                  <div className="static-input">
                    {myUtilities.accountSpecificLanguage(
                      "generic.pte.form.customerno",
                      "Customer Number")}
                  </div>
                }
              /> }
             <Row className="topbuild-row-margin-top">
              <Col md={12} className="topbuild-row-margin-top-column">
                { this.props.customerFields && this.createCustomerFields() }
              </Col>
             </Row>
              { this.renderInvoiceNumberFields(data) }
              <br />
              <div className="multiple-invoice-info">
              {!this.state.showInvoiceAmountField && myUtilities.accountSpecificLanguage(
                  "generic.pte.form.invoice.multiple.info",
                  "For multiple invoices please enter comma seperated invoice numbers")}
              </div>
              <Row className="topbuild-row-margin-top">
                <Col sm={5} />
                <Col sm={2}>
                      <input
                        type="submit"
                        value={myUtilities.accountSpecificLanguage("submit", "Submit")}
                        className="topbuild-submit-button static-invoice-button"
                      />
                </Col>
                <Col sm={5} />
              </Row>
            </form>
            <Row className="adjust-top-margin adjust-top-margin-btm" />
          </Container> </> : <FirstLoading />
        )}
      </Subscribe>
    );
  }
}

const mapStateToProps = state => ({ checkIfCallComplete: state.callComplete.checkHideCustNum, hideCustomerNumber: state.callComplete.hideCustomerNumber, showInvoiceAmountFieldRedux: state.callComplete.showInvoiceAmountField, customerFields: state.callComplete.customerFields })

// export default TopBuildPayThroughEmailForm;
export default connect(mapStateToProps)(TopBuildPayThroughEmailForm)
